import { createTheme, Modal } from "@mantine/core";

import modalClasses from "@admin/styles/modal.module.css";

export const theme = createTheme({
	primaryColor: "blue",
	colors: {
		// Custom color palette
		dark: [
			"#C1C2C5", // 0
			"#A6A7AB", // 1
			"#909296", // 2
			"#5C5F66", // 3
			"#373A40", // 4
			"#2C2E33", // 5
			"#25262B", // 6
			"#1A1B1E", // 7
			"#141517", // 8
			"#101113", // 9
		],
		//light variants
		gray: [
			"#f8f9fa",
			"#f1f3f5",
			"#e9ecef",
			"#dee2e6",
			"#ced4da",
			"#adb5bd",
			"#868e96",
			"#495057",
			"#343a40",
			"#212529",
		],
	},
	fontSizes: {
		xs: "0.75rem",
		sm: "0.85rem",
		md: "0.9rem",
		lg: "1.1rem",
		xl: "1.5rem",
	},

	/* by default it applies a blur backdrop filter which would be fine if it was only on
background element but it isn't. In the departure modal notes, it was blurring the text when 
certain elements were/weren't in focus - which is unacceptable. */

	components: {
		Modal: Modal.extend({
			defaultProps: {
				centered: true,
				classNames: { inner: modalClasses.centeredInner },
				zIndex: 1000,
			},
		}),
		Overlay: {
			styles: {
				root: {
					backdropFilter: "none",
					WebkitBackdropFilter: "none",
				},
			},
		},
		AppShell: {
			styles: {
				root: {
					"--app-shell-navbar-width": "250px",
				},
			},
		},
	},
});
